import http from '@plugin/axios'

export function getSrmBarRuleHeadByBarRuleNo(barRuleNo: string) {
  return http({
    url: '/srmBarRuleHead/getSrmBarRuleHeadByBarRuleNo',
    baseURL: process.env.VUE_APP_BASE_DATA_API,
    data: { barRuleNo }
  })
}

export function getSrmBarRuleBodyListByParams(barRuleNo: string) {
  return http({
    url: '/srmBarRuleBody/getSrmBarRuleBodyListByParams',
    baseURL: process.env.VUE_APP_BASE_DATA_API,
    data: { barRuleNo }
  })
}

export function updateSrmBarRuleHeadByBarRuleNo(params: object) {
  return http({
    url: '/srmBarRuleHead/updateSrmBarRuleHeadByBarRuleNo',
    baseURL: process.env.VUE_APP_BASE_DATA_API,
    data: params
  })
}

export function addSrmBarRuleHead(params: object) {
  return http({
    url: '/srmBarRuleHead/addSrmBarRuleHead',
    baseURL: process.env.VUE_APP_BASE_DATA_API,
    data: params
  })
}
